const installation = {
  noConfigurableParameters: "Nenhum parâmetro configurável para este fluxo.",
  noPromptsConfigured: "Nenhum prompt configurado para este fluxo.",
  promptSection: "Seção",
  promptSections: "Sessões de Prompts",
  promptSectionTitle: "Título da sessão",
  promptPlaceholder: "Digite o conteúdo do prompt...",
  promptHint: "Você pode revisar e personalizar este prompt conforme necessário",
  promptBlocked: "Este prompt está bloqueado e não pode ser editado",
  promptAddSection: "Adicionar Sessão",
  promptAddFirstSection: "Adicionar Primeira Sessão",
  promptRemoveSection: "Remover sessão",
  promptNewSection: "Nova Sessão",
  successTitle: "Fluxo Instalado com Sucesso!",
  successMessage: "O fluxo {{agent}} foi instalado e configurado com sucesso em seu workspace.",
  triggerGenerated: "Trigger Gerado",
  readyToInstall: "Tudo pronto para instalar!",
  readyDescription: "Suas configurações foram validadas e o fluxo está pronto para ser instalado.",
  installationInProgress: "Instalação em andamento...",
  installationFailed: "Instalação falhou.",
  installationComplete: "Instalação completa!",
  installationCancelled: "Instalação cancelada.",
  install: "Instalar",
  nextStep: "Próximo",
  previousStep: "Anterior",
  cancel: "Cancelar",
  wizardDescription: "Este assistente irá guiá-lo pelo processo de instalação do fluxo.",
  installing: "Instalando...",
  close: "Fechar",
  stepIndicator: "Etapa {{current}} de {{total}}",

  installationProcess: {
    copying: "Copiando...",
    integrations: "Integrando...",
    parameters: "Parametrizando...",
    publishing: "Publicando...",
    exporting: "Exportando...",
    finalizing: "Finalizando...",
    currentStep: "Preparando instalação...",
    workflow: "Preparando fluxo...",
    triggerGenerated: "Trigger gerado com sucesso!",
    finishing: "Finalizando Instalação...",
    finished: "Instalação Finalizada!"
  },

  warnings: {
    triggerNotSaved:
      "O fluxo foi instalado, mas o trigger principal não pôde ser salvo. Abra as configurações do fluxo e salve o trigger novamente.",
    secretNotStored:
      "O fluxo foi instalado, mas uma credencial não pôde ser armazenada com segurança e, por isso, não foi salva. Abra as configurações do fluxo e informe-a novamente.",
  },

};

export default installation;
